var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const makeTokenRequest = (ajaxService, tokenRequestParameters) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield ajaxService.send(tokenRequestParameters.url, tokenRequestParameters.options);
    const responseText = yield response.text();
    if (response.status < 200 || response.status > 299) {
        const message = getResponseErrorMessage(responseText) || response.statusText;
        throw new Error(message);
    }
    if (tokenRequestParameters.parser) {
        return tokenRequestParameters.parser(responseText);
    }
    return responseText;
});
const getResponseErrorMessage = (responseText) => {
    if (responseText) {
        try {
            const responseData = JSON.parse(responseText);
            return responseData.message || responseData.Message;
        }
        catch (e) {
            console.warn(e);
        }
    }
};
//# sourceMappingURL=makeTokenRequest.js.map